import { render, staticRenderFns } from "./No24.vue?vue&type=template&id=0d201d2a&scoped=true"
import script from "./No24.vue?vue&type=script&lang=js"
export * from "./No24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d201d2a",
  null
  
)

export default component.exports